<template>
  <c-selectable
    v-bind="$attrs"
    position="left"
    class="c-checkbox"
    :selected="value"
    :disabled="disabled"
    :data-testid="dataTestId"
    @toggle="$emit('input', !value)"
  >
    <p v-if="label" class="label" v-html="label" />

    <div
      v-if="tooltip"
      v-tooltip.dark="tooltip"
      class="tooltip-target"
    />
  </c-selectable>
</template>

<script>
import { tooltip } from '@convenia/components/directives'
import { toKebabCase } from '@convenia/helpers'
import CSelectable from '@convenia/components/CSelectable'
import props from './props'

export default {
  name: 'CCheckbox',

  directives: {
    tooltip
  },

  components: {
    CSelectable
  },

  props,

  computed: {
    /**
     * The data-testid attribute for the checkbox.
     */
    dataTestId () {
      if (!this.label) return 'checkbox-abstract'
      return `checkbox-${toKebabCase(this.label)}`
    }
  },
}
</script>

<style lang="scss">
.c-checkbox {
  display: flex;

  &.-disabled > .label { color: unset; }

  & > .tooltip-target {
    position: absolute;
    left: 0;
    height: 100%;
    width: var(--icon-size);
  }

  & > .label {
    margin-left: 15px;
    font-size: 14px;
    font-weight: 400;
    color: color-var(text, base-80);

    html.ios.iphone & {
      line-height: 19px;
      min-height: 19px;
    }

    line-height: 20px;
    min-height: 20px;

    @include responsive (tablet, desktop) {
       margin-left: 20px;

       line-height: 25px;
       min-height: 25px;
    }

    & > b {
      font-weight: 700;
      -webkit-font-smoothing: antialiased;
    }
  }
}
</style>
